import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'

type UseGetProjects = () => {
    getImage: (imageId: string) => string
    images: any[]
}

const useGetProjects: UseGetProjects = () => {
    const data = useStaticQuery(graphql`
        query GetImages {
            shd {
                objects {
                    findImage(where: { module: { _eq: "QfMqQn6RB2" } }) {
                        results {
                            objectId
                            name
                            filePath
                            createdAt
                            updatedAt
                        }
                    }
                }
            }
        }
    `)

    const getImage = (imageId: string) => {
        const images = data.shd.objects.findImage.results
        const image = images.find((image: any) => image.objectId === imageId)
        if (image && image.filePath) {
            return image.filePath
        } else {
            return '';
        }
    }

    return {
        getImage,
        images: data.shd.objects.findImage.results,
    }
}

export default useGetProjects